/* <product-info> — varyant değişimi (Section Rendering API), adet → buton toplamı, sepete eklendi durumu,
   yapışkan çubuk, paylaş menüsü. <product-gallery> — galeri, zoom, lightbox. */
(() => {
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!customElements.get('product-info')) {
    class ProductInfo extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.form = document.getElementById(this.dataset.formId);
        this.cache = {};
        this.requestId = 0;
        this.unsubs = [];

        this.addEventListener('change', (e) => {
          if (e.target.closest('[data-variant-picker]')) this.onOptionChange();
          else if (e.target.matches('[data-qty-input]')) this.updateTotal();
        });
        this.addEventListener('click', (e) => {
          const notify = e.target.closest('[data-notify-focus]');
          if (notify) {
            e.preventDefault();
            this.focusNotify();
          }
        });

        // Bu formdan gönderim → cart-drawer.js ekler; biz yalnızca sonuç durumunu gösteririz
        if (this.form) {
          this.form.addEventListener('submit', () => {
            this.pending = true;
            this.showError(null);
          });
          this.unsubs.push(
            CPL.subscribe(CPL.events.cartUpdate, ({ source } = {}) => {
              if (!this.pending || source !== 'product-form') return;
              this.pending = false;
              this.flashAdded();
            }),
            CPL.subscribe(CPL.events.cartError, (data) => {
              if (!this.pending) return;
              this.pending = false;
              this.showError((data && (data.description || data.message)) || window.cplStrings?.cartError);
            })
          );
        }

        this.initSticky();
        this.initShare();
      }

      disconnectedCallback() {
        this.unsubs.forEach((u) => u());
        if (this.observer) this.observer.disconnect();
        document.body.classList.remove('has-sticky-atc');
      }

      get variants() {
        if (!this._variants) {
          try {
            this._variants = JSON.parse(this.querySelector('[data-variant-json]').textContent);
          } catch (e) {
            this._variants = [];
          }
        }
        return this._variants;
      }

      /* Varyant */
      onOptionChange() {
        const picker = this.querySelector('[data-variant-picker]');
        const selected = Array.from(picker.querySelectorAll('fieldset')).map(
          (fs) => (fs.querySelector('input:checked') || {}).value
        );
        const variant = this.variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
        const input = this.form && this.form.querySelector('[data-variant-input]');

        if (!variant) {
          if (input) input.disabled = true;
          const btn = this.querySelector('[data-add-button]');
          if (btn) {
            btn.disabled = true;
            const label = btn.querySelector('[data-add-label]');
            if (label) label.textContent = window.cplStrings?.unavailable || '';
          }
          return;
        }

        if (input) {
          input.disabled = false;
          input.value = variant.id;
        }
        if (this.hasAttribute('data-update-url')) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
        const qty = this.querySelector('[data-qty]');
        if (qty) qty.hidden = !variant.available;

        const gallery = this.querySelector('product-gallery');
        if (gallery && variant.featured_media) gallery.goToMedia(variant.featured_media.id);

        this.renderVariant(variant);
        CPL.publish(CPL.events.variantChange, { sectionId: this.sectionId, variant });
      }

      async renderVariant(variant) {
        const id = ++this.requestId;
        const url = `${this.dataset.url}?variant=${variant.id}&section_id=${this.sectionId}`;
        try {
          const html = this.cache[url] || (this.cache[url] = await fetch(url).then((r) => r.text()));
          if (id !== this.requestId) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const active = document.activeElement;
          const activeId = active && this.contains(active) ? active.id : null;

          this.querySelectorAll('[data-update]').forEach((el) => {
            const fresh = doc.querySelector(`[data-update="${el.dataset.update}"]`);
            if (fresh) el.innerHTML = fresh.innerHTML;
          });
          this._variants = null;
          if (activeId) document.getElementById(activeId)?.focus({ preventScroll: true });
          this.updateTotal();
        } catch (e) {
          /* ağ hatası: sayfa yenilenince doğru durum gelir */
        }
      }

      /* Adet → "Sepete ekle · ₺toplam" */
      updateTotal() {
        const btn = this.querySelector('[data-add-button][data-show-total]');
        if (!btn) return;
        const qtyInput = this.querySelector('[data-qty-input]');
        const qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        const label = btn.querySelector('[data-add-label]');
        if (label && !btn.classList.contains('is-added')) {
          label.textContent = `${btn.dataset.label} · ${CPL.formatMoney(Number(btn.dataset.price) * qty)}`;
        }
      }

      flashAdded() {
        const btn = this.querySelector('[data-add-button]');
        if (!btn) return;
        const label = btn.querySelector('[data-add-label]');
        clearTimeout(this.addedTimer);
        btn.classList.add('is-added');
        if (label) label.textContent = this.dataset.addedText || window.cplStrings?.addedToCart || '';
        this.addedTimer = setTimeout(() => {
          btn.classList.remove('is-added');
          if (label) label.textContent = btn.dataset.label;
          this.updateTotal();
        }, 1600);
      }

      showError(message) {
        const el = this.querySelector('[data-form-error]');
        if (!el) return;
        el.hidden = !message;
        el.textContent = message || '';
      }

      focusNotify() {
        const input = this.querySelector('.product-notify input[type="email"]');
        if (!input) return;
        input.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
        input.focus({ preventScroll: true });
      }

      /* Yapışkan çubuk: ana satın alma satırı ekranın üstünden çıkınca */
      initSticky() {
        const bar = this.querySelector('[data-sticky-atc]');
        const target = this.querySelector('[data-buy-row]');
        if (!bar || !target || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(([entry]) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', show);
          bar.inert = !show;
          document.body.classList.toggle('has-sticky-atc', show);
        });
        this.observer.observe(target);
      }

      /* Paylaş menüsü: dışarı tıklama ve Esc ile kapanır */
      initShare() {
        const details = this.querySelector('[data-share]');
        if (!details) return;
        document.addEventListener('click', (e) => {
          if (details.open && !details.contains(e.target)) details.open = false;
        });
        details.addEventListener('keyup', (e) => {
          if (e.key !== 'Escape' || !details.open) return;
          details.open = false;
          details.querySelector('summary').focus();
        });
        details.addEventListener('click', (e) => {
          if (e.target.closest('copy-button')) setTimeout(() => (details.open = false), 150);
        });
      }
    }
    customElements.define('product-info', ProductInfo);
  }

  if (!customElements.get('product-gallery')) {
    class ProductGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-gallery-track]');
        if (!this.track) return;
        this.slides = Array.from(this.track.querySelectorAll('[data-gallery-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
        this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
        this.counter = this.querySelector('[data-gallery-counter]');
        this.index = 0;

        let raf;
        this.track.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => {
              const w = this.track.clientWidth || 1;
              this.setActive(Math.round(this.track.scrollLeft / w));
            });
          },
          { passive: true }
        );
        this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(Number(t.dataset.galleryThumb))));

        if (this.hasAttribute('data-zoom')) this.initZoom();
        this.initLightbox();
      }

      setActive(i) {
        if (i === this.index || i < 0 || i >= this.slides.length) return;
        this.index = i;
        this.thumbs.forEach((t, n) => {
          t.classList.toggle('is-active', n === i);
          if (n === i) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
        this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
        if (this.counter) this.counter.textContent = `${i + 1} / ${this.slides.length}`;
      }

      goTo(i, instant) {
        const slide = this.slides[i];
        if (!slide) return;
        this.track.scrollTo({ left: slide.offsetLeft, behavior: instant || reduceMotion() ? 'auto' : 'smooth' });
        this.setActive(i);
      }

      goToMedia(mediaId) {
        const i = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
        if (i > -1) this.goTo(i);
      }

      /* Masaüstü hover zoom: imleç konumuna göre büyüt */
      initZoom() {
        const mq = window.matchMedia('(hover: hover) and (min-width: 990px)');
        this.track.addEventListener('mousemove', (e) => {
          if (!mq.matches) return;
          const btn = e.target.closest('.product-gallery__zoom');
          if (!btn) return;
          const img = btn.querySelector('img');
          if (!img) return;
          const r = btn.getBoundingClientRect();
          img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
          btn.classList.add('is-zoomed');
        });
        this.track.addEventListener('mouseout', (e) => {
          const btn = e.target.closest('.product-gallery__zoom');
          if (btn && !btn.contains(e.relatedTarget)) btn.classList.remove('is-zoomed');
        });
      }

      initLightbox() {
        const modal = this.querySelector('modal-dialog.lightbox');
        if (!modal) return;
        const track = modal.querySelector('[data-lightbox-track]');
        const slides = Array.from(track.children);
        const counter = modal.querySelector('[data-lightbox-counter]');
        let current = 0;
        const update = (i) => {
          current = Math.max(0, Math.min(slides.length - 1, i));
          if (counter) counter.textContent = `${current + 1} / ${slides.length}`;
          modal.querySelector('[data-lightbox-prev]').disabled = current === 0;
          modal.querySelector('[data-lightbox-next]').disabled = current === slides.length - 1;
        };
        const go = (i, instant) => {
          update(i);
          track.scrollTo({ left: slides[current].offsetLeft, behavior: instant || reduceMotion() ? 'auto' : 'smooth' });
        };
        modal.addEventListener('modal:open', () => {
          const i = Number(modal.opener && modal.opener.dataset.index) || 0;
          requestAnimationFrame(() => go(i, true));
        });
        modal.querySelector('[data-lightbox-prev]').addEventListener('click', () => go(current - 1));
        modal.querySelector('[data-lightbox-next]').addEventListener('click', () => go(current + 1));
        modal.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') go(current - 1);
          if (e.key === 'ArrowRight') go(current + 1);
        });
        let raf;
        track.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => update(Math.round(track.scrollLeft / (track.clientWidth || 1))));
          },
          { passive: true }
        );
      }
    }
    customElements.define('product-gallery', ProductGallery);
  }
})();
